import React from 'react';
import { Controller } from 'react-hook-form';
import { isValueValid } from "../formRenderer/utils/helper.js";
import { InputPassword } from "../inputPassword/InputPassword.js";

// ToDo: Get rid of internal proxy input prop type -> Breaking change for next major version
import { jsx as _jsx } from "react/jsx-runtime";
export function FormInputPassword({
  control,
  name,
  rules,
  defaultValue,
  inputPasswordProps,
  showCheckmark
}) {
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    rules: rules,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        onBlur,
        value,
        name,
        ref
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/_jsx(InputPassword, {
      ...inputPasswordProps,
      onChange,
      name,
      value,
      inputRef: ref,
      onBlur: e => {
        onBlur();
        inputPasswordProps.onBlur?.(e);
      },
      error: error?.message === 'true' ? true : error?.message,
      valid: showCheckmark && isValueValid(error, value)
    })
  });
}